export default ['/public-registry'];
